import { render, staticRenderFns } from "./table.components.vue?vue&type=template&id=14910ffb&scoped=true&"
import script from "./table.components.vue?vue&type=script&lang=js&"
export * from "./table.components.vue?vue&type=script&lang=js&"
import style0 from "./table.components.vue?vue&type=style&index=0&id=14910ffb&lang=scss&scoped=true&"
import style1 from "./table.components.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14910ffb",
  null
  
)

export default component.exports